<div
	style="position: relative"
	[style.width]="responsive && !width ? null : width"
	[style.height]="responsive && !height ? null : height"
>
	<canvas
		[attr.width]="responsive && !width ? null : width"
		[attr.height]="responsive && !height ? null : height"
		(click)="onCanvasClick($event)"
	></canvas>
</div>
